import Header from "../../components/shared/Header";
import "../../styles/shared/Plans.scss";
import HeroImage from "../../images/bussinessPlus.png";
import SolutionImage1 from "../../images/SolarRoofTop.png";
import SolutionImage2 from "../../images/cc-monitoring-certificate.png";
import SolutionImage3 from "../../images/verification.png";
import SolutionImage4 from "../../images/SolutionImage3.png";
import efficiency  from "../../images/efficiency.png";
import Focus from "../../images/SolarPlus.png";
import { useEffect, useState } from "react";
import GreenLogo from "../../images/Group 32.png";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/shared/Footer";
import BusinessPlusFaq from "../../components/NewLandingPage/BusinessPlusFag";
import BasicCollaborators from "../../components/shared/BasicCollaborators.jsx";

export default function BusinessPlus() {
  const navigate = useNavigate();
  const [type, setType] = useState("tracking");
  const [planVideo, setplanVideo] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const nextBtn = document.querySelector(".feedback__inner__group__svg-group__next");
    const prevBtn = document.querySelector(".feedback__inner__group__svg-group__prev");
    const slider = document.querySelector(".feedback__inner__cards");
    const card = document.querySelector(".feedback__inner__cards__card");
    let itemDimensions = card.getBoundingClientRect();
    let amountToSlide = (itemDimensions.width + 24) * 3;

    nextBtn.addEventListener("click", () => {
      slider.scrollLeft += amountToSlide;
      console.log(
        'nextBtn', nextBtn,
        'prevBtn', prevBtn,
        'slider', slider,
        'card', card,
        'itemDimensions', itemDimensions,
        'amountToSlide', amountToSlide
      );
    });

    prevBtn.addEventListener("click", () => {
      slider.scrollLeft -= amountToSlide;
    });

  }, [])

  return (
    <div className="plans">
      <Header />
      <div className="hero">
        <div className="hero__inner">
          <div className="hero__inner__title">
            CloseCarbon <span>Business Plus</span>
          </div>
          <div className="hero__inner__subtitle">
          All Business Plan features. Peer to Peer Energy Trading Plus Decentralized Energy Trading.       </div>
          <div className="hero__inner__price">
            Starting at ₦19,995 <span>Monthly</span>
          </div>
          <div className="hero__inner__button-group">
            <button onClick={() => navigate('/template/business-plus')}>Choose plan</button>
            <button
             onClick={() => {
              window.open("https://youtu.be/On9PHYLfZOk?si=Wtdk1jT5j71VwzFl", "_blank", "noopener,noreferrer");
            }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.155 13.7501C3.96313 13.7497 3.77466 13.6994 3.60812 13.6041C3.23312 13.3916 3 12.9791 3 12.5313V3.46881C3 3.01974 3.23312 2.60849 3.60812 2.39599C3.77863 2.298 3.97232 2.24761 4.16896 2.25009C4.36559 2.25256 4.55796 2.30781 4.72594 2.41006L12.4712 7.04631C12.6327 7.14752 12.7657 7.28807 12.858 7.45479C12.9502 7.6215 12.9986 7.8089 12.9986 7.99943C12.9986 8.18996 12.9502 8.37736 12.858 8.54408C12.7657 8.71079 12.6327 8.85134 12.4712 8.95256L4.72469 13.5901C4.55278 13.694 4.35588 13.7493 4.155 13.7501Z"
                  fill="#0FA958"
                />
              </svg>
              Watch now
            </button>
          </div>

          <img className="hero__inner__img" src={HeroImage} alt="" loading='lazy' />
        </div>
      </div>
      <div className="solution">
        <div className="solution__title">
            The <span>solution</span> you need for the sustainability journey<br></br> you want
        </div>
        <div className="solution__subtitle">
         Business Plus integrates carbon management with blockchain-enabled energy markets, creating a comprehensive sustainability ecosystem.
        </div>
        <div className="solution__grid">
          <div className="solution__grid__nav">
            <div
              className={
                type === "tracking"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("tracking")}
            >
              <div className="solution__grid__nav__item__title">Peer to Peer Energy Trading</div>
              {type === "tracking" && (
                <div className="solution__grid__nav__item__subtitle">
Engage in secure, decentralized solar energy trading through blockchain-based smart contracts and tokenized energy credits. Buy or sell surplus renewable energy within a transparent pricing framework.                </div>
              )}
            </div>
            <div
              className={
                type === "credit"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("credit")}
            >
              <div className="solution__grid__nav__item__title">
   Advanced Energy Efficiency
              </div>
              {type === "credit" && (
                <div className="solution__grid__nav__item__subtitle">
Monitor real-time energy production and consumption, identify inefficiencies, and receive smart recommendations for optimizing performance. </div>              )}
            </div>
            <div
              className={
                type === "verification"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("verification")}
            >
              <div className="solution__grid__nav__item__title">
              Verification
              </div>
              {type === "verification" && (
                <div className="solution__grid__nav__item__subtitle">
Your emissions data is independently reviewed by certified verifiers to ensure accuracy, reliability, and compliance with recognized carbon methodologies and standards.                 </div>
              )}
            </div>
            <div
              className={
                type === "insights"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("insights")}
            >
              <div className="solution__grid__nav__item__title">
         Carbon Incentive (CCRTs)
              </div>
              {type === "insights" && (
                <div className="solution__grid__nav__item__subtitle">
Earn CloseCarbon Reduction Tonne for verified emissions reductions and measurable energy efficiency improvements. </div>              )}
            </div>
          </div>
          {type === "tracking" && (
            <img loading='lazy' src={SolutionImage1} className="solution__grid__img w-[540px]" />
          )}
          {type === "credit" && (
            <img loading='lazy' src={efficiency} className="solution__grid__img" />
          )}
          {type === "verification" && (
            <img loading='lazy' src={SolutionImage3} className="solution__grid__img" />
          )}
          {type === "insights" && (
            <img loading='lazy' src={SolutionImage4} className="solution__grid__img" />
          )}
        </div>
      </div>
      <div className="feedback">
        <div className="feedback__inner">
          <div className="feedback__inner__group">
            <div className="feedback__inner__group__title">
              Feedback from our customers
            </div>
            <div className="feedback__inner__group__subtitle">
              We’re trusted by several organizations
            </div>
            <div className="feedback__inner__group__svg-group">
              <div className="feedback__inner__group__svg-group__prev">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM17 7L1 7V9L17 9V7Z" />
                </svg>
              </div>

              <div className="feedback__inner__group__svg-group__next">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289L10.3431 0.928932C9.95262 0.538408 9.31946 0.538408 8.92893 0.928932C8.53841 1.31946 8.53841 1.95262 8.92893 2.34315L14.5858 8L8.92893 13.6569C8.53841 14.0474 8.53841 14.6805 8.92893 15.0711C9.31946 15.4616 9.95262 15.4616 10.3431 15.0711L16.7071 8.70711ZM0 9H16V7H0L0 9Z" />
                </svg>
              </div>
            </div>
          </div>
          <div className="feedback__inner__cards">
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>
              <div className="feedback__inner__cards__card__title">
              With the Business Plus Plan, we finally had access to downloadable reports and certificates for our emissions tracking. The plan feels tailored for businesses like ours looking to document their climate efforts seriously without extra validation layers              </div>
              <div className="feedback__inner__cards__card__subtitle" >Chuka Ezeani</div>
            <div></div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              We appreciated the ability to categorize our facility and monitor carbon outputs without involving verifiers. It gave us speed and flexibility while staying accountable. The monthly payment option made it easy to onboard with low friction.              </div>
             
               <div className="feedback__inner__cards__card__subtitle">
               Lucía Kelvin
              </div>
              <div></div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              What I love most is the autonomy this plan gives us. The dashboard is insightful, and we can view reports anytime. It’s efficient for organizations that want control over their carbon tracking and certification              </div>
              <div className="feedback__inner__cards__card__subtitle">
              Thomas Eriksson
              </div>
              <div></div>
            </div>
            {/* <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              CloseCarbon's governance plan made it incredibly easy for me to track my carbon emissions. I'm impressed with the simplicity and effectiveness of the tools provided.
              </div>
              <div className="feedback__inner__cards__card__subtitle">
                Samuel
              </div>
              <div>LS Truval</div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              I've been using CloseCarbon's governance plan for a month now, and I'm already seeing positive changes in my carbon footprint. The real-time tracking feature is especially helpful in keeping me accountable.
              </div>
              <div className="feedback__inner__cards__card__subtitle">
                Samuel
              </div>
              <div>LS Truval</div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              This governance plan makes me feel more empowered to make sustainable choices in my daily life. The user-friendly interface have been instrumental in guiding me towards a greener lifestyle.
              </div>
              <div className="feedback__inner__cards__card__subtitle">
                Samuel
              </div>
              <div>LS Truval</div>
            </div> */}
            
          </div>
        </div>
      </div>

      <div className="unlock">
        <div className="unlock__card1">
          <div className="unlock__card1__title">
          Unlock the potential of<br/>
          <span className="text-[#0D924F]"> Business Plus plan</span>
          </div>
          <div className="unlock__card1__subtitle">
          Access a secure, decentralized marketplace to buy or sell surplus solar energy. Trade energy within a set price range and enjoy fair, transparent transactions for everyone involved. Also, monitor real-time energy, identify high-consumption areas and get smart efficiency actions to make smarter energy decisions.          </div>
          <img loading="lazy" className="unlock__card1__img" src={Focus} alt="" />
        </div>
        <div className="unlock__card2">
          <div className="unlock__card2__flex">
            <img loading="lazy" src={GreenLogo} />
           <div>
              <div className="text-[20px] font-semibold">Business plus plan</div>

              <div className="text-[#898989]">
               Peer to Peer Energy Trading 
              </div>
              </div>
              <>
                  <div className=" 0">
                 <div className="text-[#0D924F] text-6xl font-bold  ml-20">₦19,995</div>
            <div className="ml-40 text-gray-500">Monthly</div>

                  </div>
                  <div>

                  </div>
                  </>
          </div>
          
          <div className="unlock__card2__price">
       
          </div>
          <div className="unlock__card2__divider"></div>
          <div className="unlock__card2__more-info">
            <div className="unlock__card2__more-info__title">How it works:</div>
            <div className="unlock__card2__more-info__flex">
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M10.842 10.8327C10.7683 9.8763 10.9893 8.92024 11.4753 8.09322C11.9614 7.2662 12.6891 6.60793 13.5606 6.20701C14.432 5.8061 15.4054 5.68177 16.3497 5.85078C17.2939 6.01979 18.1637 6.47401 18.842 7.15232C19.5203 7.83062 19.9746 8.70044 20.1436 9.6447C20.3126 10.589 20.1883 11.5623 19.7873 12.4338C19.3864 13.3053 18.7282 14.033 17.9011 14.519C17.0741 15.0051 16.1181 15.2261 15.1616 15.1523" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.2179 16.6107C20.2179 17.1853 19.9896 17.7364 19.5833 18.1427C19.177 18.5491 18.6259 18.7773 18.0512 18.7773H16.6068M18.0512 20.2218L16.6068 18.7773L18.0512 17.3329M5.77344 9.38846C5.77344 8.81382 6.00171 8.26272 6.40804 7.85639C6.81437 7.45006 7.36547 7.22179 7.9401 7.22179H9.38455M7.9401 5.77734L9.38455 7.22179L7.9401 8.66623M10.4679 20.2218C9.22284 20.2218 8.02879 19.7272 7.14841 18.8468C6.26803 17.9664 5.77344 16.7724 5.77344 15.5273C5.77344 14.2823 6.26803 13.0882 7.14841 12.2079C8.02879 11.3275 9.22284 10.8329 10.4679 10.8329C11.7129 10.8329 12.907 11.3275 13.7874 12.2079C14.6677 13.0882 15.1623 14.2823 15.1623 15.5273C15.1623 16.7724 14.6677 17.9664 13.7874 18.8468C12.907 19.7272 11.7129 20.2218 10.4679 20.2218Z" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

              <div>
              In need of energy or you’ve excess energy to sell
              </div>
            </div>
            <div className="unlock__card2__more-info__flex">
         <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<g clip-path="url(#clip0_6047_20637)">
<path d="M14.4042 5.42905L13.1819 11.8508L17.6098 11.8657L11.5827 20.5713L12.8049 13.5064L8.37735 13.4909L14.4042 5.42905ZM14.405 4.34574C14.3758 4.34574 14.3465 4.3468 14.3178 4.34895C14.1266 4.36441 13.9999 4.42832 13.8496 4.52935C13.7649 4.58577 13.6886 4.65378 13.6229 4.73139C13.6031 4.75468 13.5845 4.77891 13.5671 4.80397L7.49687 12.8377C7.25719 13.1662 7.22198 13.5998 7.40615 13.9622C7.59004 14.3246 7.96189 14.5543 8.3695 14.5572L11.4965 14.58L10.5134 20.3723C10.42 20.8701 10.6854 21.3663 11.1526 21.5661C11.2884 21.6245 11.4346 21.6545 11.5824 21.6544C11.9228 21.6544 12.2026 21.4952 12.4125 21.2076L18.4903 12.5019C18.73 12.1733 18.7649 11.7392 18.581 11.3773C18.3971 11.015 18.0252 10.7853 17.6176 10.7823L14.4906 10.7769L15.4632 5.68389C15.4838 5.60051 15.4941 5.51493 15.4941 5.42904C15.4941 4.84295 15.0274 4.3652 14.4435 4.34624C14.4305 4.3457 14.4177 4.3457 14.405 4.3457L14.405 4.34574Z" fill="#475367"/>
</g>
<defs>
<clipPath id="clip0_6047_20637">
<rect width="17.3333" height="17.3333" fill="white" transform="translate(4.32812 4.33398)"/>
</clipPath>
</defs>
</svg>

              <div>
              List your excess energy to sell or List the energy you’ll like to purchase
              </div>
            </div>
            <div className="unlock__card2__more-info__flex">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M8.66211 5.87891H12.2744C12.3561 5.87848 12.437 5.89489 12.5127 5.92578C12.5506 5.94126 12.5871 5.95994 12.6211 5.98242L12.7158 6.05957L19.9375 13.2891C19.9951 13.3466 20.0411 13.415 20.0723 13.4902C20.1034 13.5654 20.1201 13.6461 20.1201 13.7275C20.1201 13.8089 20.1034 13.8897 20.0723 13.9648C20.0411 14.04 19.9951 14.1085 19.9375 14.166L14.1621 19.9414C14.0356 20.0616 13.8791 20.124 13.7178 20.124C13.5542 20.124 13.3995 20.0674 13.2754 19.9434L6.05371 12.7217C5.94073 12.6016 5.87305 12.4457 5.87305 12.2793V8.66797L5.88477 8.5459C5.8925 8.50589 5.90444 8.46661 5.91992 8.42871C5.95081 8.35315 5.99531 8.2836 6.05273 8.22559L6.05371 8.22656L8.21875 6.06152C8.33898 5.94768 8.49504 5.87897 8.66211 5.87891ZM7.11816 8.92969V12.0244L7.14746 12.0537L13.6475 18.5469L13.6943 18.498L13.7812 18.5615L18.6113 13.7314L18.541 13.6602L12.0117 7.13086H8.91699L7.11816 8.92969Z" fill="#475367" stroke="#F0F2F5" stroke-width="0.2"/>
<path d="M10.1085 8.66797C9.31406 8.66797 8.66406 9.31797 8.66406 10.1124C8.66406 10.9069 9.31406 11.5569 10.1085 11.5569C10.903 11.5569 11.553 10.9069 11.553 10.1124C11.553 9.31797 10.903 8.66797 10.1085 8.66797Z" fill="#475367"/>
</svg>


              <div>
              Choose your preferred one, ensure close proximity, be sure the price falls within your range.
              </div>
            </div>
            <div className="unlock__card2__more-info__flex">
       <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M5.77344 7.58398H10.6535C10.9381 7.58395 11.22 7.64 11.4829 7.74892C11.7459 7.85785 11.9848 8.01752 12.186 8.21882L14.4401 10.4729M7.9401 14.084H5.77344M10.4679 9.75065L11.9123 11.1951C12.0072 11.2899 12.0824 11.4025 12.1337 11.5265C12.1851 11.6504 12.2115 11.7832 12.2115 11.9173C12.2115 12.0514 12.1851 12.1843 12.1337 12.3082C12.0824 12.4321 12.0072 12.5447 11.9123 12.6395C11.8175 12.7344 11.7049 12.8096 11.581 12.8609C11.457 12.9123 11.3242 12.9387 11.1901 12.9387C11.056 12.9387 10.9232 12.9123 10.7992 12.8609C10.6753 12.8096 10.5627 12.7344 10.4679 12.6395L9.38455 11.5562C8.76344 12.1773 7.77905 12.2474 7.0756 11.7202L6.85677 11.5562" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.9375 12.2782V15.5282C7.9375 16.8903 7.9375 17.5707 8.36072 17.9939C8.78394 18.4171 9.46428 18.4171 10.8264 18.4171H17.3264C18.6885 18.4171 19.3688 18.4171 19.7921 17.9939C20.2153 17.5707 20.2153 16.8903 20.2153 15.5282V13.3615C20.2153 11.9994 20.2153 11.3191 19.7921 10.8959C19.3688 10.4727 18.6885 10.4727 17.3264 10.4727H11.1875" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.3403 14.4455C15.3403 14.7807 15.2071 15.1022 14.9701 15.3392C14.7331 15.5763 14.4116 15.7094 14.0764 15.7094C13.7412 15.7094 13.4197 15.5763 13.1827 15.3392C12.9457 15.1022 12.8125 14.7807 12.8125 14.4455C12.8125 14.1103 12.9457 13.7889 13.1827 13.5518C13.4197 13.3148 13.7412 13.1816 14.0764 13.1816C14.4116 13.1816 14.7331 13.3148 14.9701 13.5518C15.2071 13.7889 15.3403 14.1103 15.3403 14.4455Z" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


              <div>Make payment by choosing the payment plan that you prefer.</div>
            </div>
            <div className="unlock__card2__more-info__flex">
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<g clip-path="url(#clip0_6047_20659)">
<path d="M14.4042 5.42905L13.1819 11.8508L17.6098 11.8657L11.5827 20.5713L12.8049 13.5064L8.37735 13.4909L14.4042 5.42905ZM14.405 4.34574C14.3758 4.34574 14.3465 4.3468 14.3178 4.34895C14.1266 4.36441 13.9999 4.42832 13.8496 4.52935C13.7649 4.58577 13.6886 4.65378 13.6229 4.73139C13.6031 4.75468 13.5845 4.77891 13.5671 4.80397L7.49687 12.8377C7.25719 13.1662 7.22198 13.5998 7.40615 13.9622C7.59004 14.3246 7.96189 14.5543 8.3695 14.5572L11.4965 14.58L10.5134 20.3723C10.42 20.8701 10.6854 21.3663 11.1526 21.5661C11.2884 21.6245 11.4346 21.6545 11.5824 21.6544C11.9228 21.6544 12.2026 21.4952 12.4125 21.2076L18.4903 12.5019C18.73 12.1733 18.7649 11.7392 18.581 11.3773C18.3971 11.015 18.0252 10.7853 17.6176 10.7823L14.4906 10.7769L15.4632 5.68389C15.4838 5.60051 15.4941 5.51493 15.4941 5.42904C15.4941 4.84295 15.0274 4.3652 14.4435 4.34624C14.4305 4.3457 14.4177 4.3457 14.405 4.3457L14.405 4.34574Z" fill="#475367"/>
</g>
<defs>
<clipPath id="clip0_6047_20659">
<rect width="17.3333" height="17.3333" fill="white" transform="translate(4.32812 4.33398)"/>
</clipPath>
</defs>
</svg>


              <div>Energy is released to your account.</div>
            </div>
            <div className="unlock__card2__more-info__flex">
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M12.0294 12.0312C11.7718 12.2876 11.6263 12.6356 11.625 12.999C11.625 13.363 11.7696 13.712 12.0269 13.9693C12.2843 14.2267 12.6333 14.3712 12.9972 14.3712C13.3606 14.3699 13.7087 14.2245 13.965 13.9668" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.9917 8.88281C12.1775 8.88281 11.3816 9.12425 10.7046 9.5766C10.0276 10.0289 9.49995 10.6719 9.18836 11.4241C8.87678 12.1763 8.79526 13.004 8.9541 13.8026C9.11294 14.6012 9.50502 15.3347 10.0807 15.9104C10.6565 16.4861 11.39 16.8782 12.1885 17.037C12.9871 17.1959 13.8148 17.1144 14.567 16.8028C15.3193 16.4912 15.9622 15.9636 16.4146 15.2866C16.8669 14.6096 17.1083 13.8137 17.1083 12.9995" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.9939 6.13867C11.6369 6.13867 10.3104 6.54107 9.1821 7.29498C8.05379 8.04889 7.17439 9.12045 6.65509 10.3741C6.13579 11.6279 5.99991 13.0074 6.26465 14.3383C6.52939 15.6692 7.18284 16.8918 8.14239 17.8513C9.10193 18.8109 10.3245 19.4643 11.6554 19.7291C12.9863 19.9938 14.3659 19.8579 15.6196 19.3386C16.8733 18.8193 17.9448 17.9399 18.6987 16.8116C19.4526 15.6833 19.855 14.3568 19.855 12.9998M15.5398 10.4547L13.68 12.3137" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.4521 8.55457L17.1121 8.8839L17.4414 6.5439C17.4439 6.51672 17.4381 6.48944 17.4249 6.46554C17.4118 6.44164 17.3918 6.42221 17.3675 6.40973C17.3433 6.39725 17.3158 6.39228 17.2887 6.39547C17.2616 6.39866 17.2361 6.40985 17.2154 6.42763L15.664 7.97101C15.5047 8.13151 15.3875 8.3289 15.3229 8.54562C15.2582 8.76234 15.2482 8.99168 15.2935 9.21324L15.5405 10.4555L16.7828 10.7017C17.0043 10.7471 17.2337 10.7371 17.4504 10.6724C17.6671 10.6078 17.8645 10.4906 18.025 10.3312L19.5677 8.78063C19.5855 8.75988 19.5967 8.73427 19.5999 8.70709C19.6031 8.67991 19.598 8.65241 19.5855 8.62811C19.5729 8.60381 19.5533 8.58382 19.5293 8.57072C19.5053 8.55761 19.4779 8.55199 19.4507 8.55457" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


              <div>Set energy goal for a 6months time period, monitor your energy usage and earn CloseCarbon credit. </div>
            </div>
            <button
              className="hero-btn mt-10 group text-[16px] text-white flex justify-center items-center border-2 border-[#E4E7EC] py-[6px] gap-[10px] w-[132px]  h-[56px] bg-[#0D924F] rounded-[8px] hover:bg-[#0d713f] transition-all cursor-pointer  hover:-translate-y-0.5 "
              onClick={() => navigate('/template/business-plus')}
            >
              Choose plan
            </button>
          </div>
        </div>
      </div>
     

          <div className="bg-[#D3EEE0]">
<BusinessPlusFaq/>
      </div>
  <BasicCollaborators />
      <Footer />

    </div>
  );
}
